import React from 'react';
import * as Sentry from '@sentry/react';

function isChunkLoadError(error) {
  const msg = error?.message ?? '';
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('Unable to preload CSS') ||
    error?.name === 'ChunkLoadError'
  );
}

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (isChunkLoadError(error)) {
      window.location.reload();
      return;
    }
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.hasError && !isChunkLoadError(this.state.error)) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            background: '#f8d7da',
            color: '#721c24',
            padding: '20px',
            textAlign: 'center',
          }}
        >
          <span style={{ fontSize: '3rem', lineHeight: 1 }}>⚠️</span>
          <h1 style={{ marginTop: '1rem' }}>Something went wrong</h1>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1.5rem',
              background: '#721c24',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem',
            }}
          >
            Refresh page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
